import * as yup from 'yup';

const CreatePNLSchema = yup.object().shape({
    yearToClose: yup.number().required().moreThan(0),
    accountNumber: yup.number().required().moreThan(0),
    memo: yup.string().required(),
});

export default CreatePNLSchema;
